// extracted by mini-css-extract-plugin
module.exports = {"pg-speech-box":"ek","pgSpeechBox":"ek","speech-list-box":"el","speechListBox":"el"};